/** Traducción segura: devuelve '' si la clave no existe. */
export function tv(translate, key) {
  if (!translate) return '';
  const val = translate(key);
  return val && val !== key ? val : '';
}

export function buildAboutDefault(translate) {
  return [tv(translate, 'about_us_content2'), tv(translate, 'about_us_content1')]
    .filter(Boolean)
    .join('\n\n');
}

export function buildTermsDefault(translate, settings = {}) {
  const lines = [];
  const h1 = tv(translate, 'term_condition_para1');
  if (h1) lines.push(h1);
  for (let i = 1; i <= 12; i++) {
    const h = tv(translate, `term_condition_heading${i}`);
    const p = tv(translate, `term_condition_para${i + 1}`);
    if (h) lines.push(h);
    if (p) lines.push(p);
  }
  let last = tv(translate, 'term_condition_para14');
  if (last) {
    if (settings.contact_email) {
      last = `${last} ${settings.contact_email}`;
    }
    lines.push(last);
  }
  return lines.filter(Boolean).join('\n\n');
}

export function buildPrivacyDefault(translate, settings = {}) {
  const lines = [];
  const bullets = (...keys) =>
    keys.map((k) => tv(translate, k)).filter(Boolean).map((x) => `• ${x}`);
  const push = (...vals) => vals.forEach((v) => { if (v) lines.push(v); });

  push(
    tv(translate, 'privacy_policy_para1'),
    tv(translate, 'privacy_policy_para2'),
    tv(translate, 'privacy_policy_para3'),
  );
  push(tv(translate, 'privacy_policy_heading_info'), tv(translate, 'privacy_policy_info_para1'));
  lines.push(
    ...bullets(
      'privacy_policy_info_list1',
      'privacy_policy_info_list2',
      'privacy_policy_info_list3',
      'privacy_policy_info_list4',
    ),
  );
  push(
    tv(translate, 'privacy_policy_info_para2'),
    tv(translate, 'privacy_policy_info_para3'),
    tv(translate, 'privacy_policy_info_para4'),
  );
  lines.push(
    ...bullets(
      'privacy_policy_info_list5',
      'privacy_policy_info_list6',
      'privacy_policy_info_list7',
    ),
  );
  push(tv(translate, 'privacy_policy_info_para5'));
  push(tv(translate, 'privacy_policy_heading_log'), tv(translate, 'privacy_policy_log_para1'));
  push(
    tv(translate, 'privacy_policy_heading_cookie'),
    tv(translate, 'privacy_policy_cookie_para1'),
    tv(translate, 'privacy_policy_cookie_para2'),
  );
  push(tv(translate, 'privacy_policy_heading_service'), tv(translate, 'privacy_policy_service_para1'));
  lines.push(
    ...bullets(
      'privacy_policy_service_list1',
      'privacy_policy_service_list2',
      'privacy_policy_service_list3',
      'privacy_policy_service_list4',
    ),
  );
  push(tv(translate, 'privacy_policy_service_para2'));
  push(tv(translate, 'privacy_policy_heading_security'), tv(translate, 'privacy_policy_security_para1'));
  push(tv(translate, 'privacy_policy_heading_link'), tv(translate, 'privacy_policy_link_para1'));
  push(tv(translate, 'privacy_policy_heading_children'), tv(translate, 'privacy_policy_children_para1'));
  const deleteLabel = tv(translate, 'delete_account_lebel');
  push(
    deleteLabel ? deleteLabel.toUpperCase() : '',
    tv(translate, 'delete_account_msg'),
    tv(translate, 'delete_account_subheading'),
  );
  lines.push(...bullets('delete_account_para1', 'delete_account_para2'));
  push(
    tv(translate, 'privacy_policy_heading_change_privacy'),
    tv(translate, 'privacy_policy_change_privacy_para1'),
    tv(translate, 'privacy_policy_change_privacy_para2'),
  );
  let contact = tv(translate, 'privacy_policy_contact_para1');
  if (contact && settings.contact_email) {
    contact = `${contact} ${settings.contact_email}`;
  }
  push(tv(translate, 'privacy_policy_heading_contact'), contact);
  return lines.filter(Boolean).join('\n\n');
}

export function buildFaqDefault(translate) {
  const lines = [];
  for (let i = 1; i <= 8; i++) {
    const q = tv(translate, `faq_q${i}`);
    const a = tv(translate, `faq_a${i}`);
    if (q) lines.push(q);
    if (a) lines.push(a);
    if (q || a) lines.push('');
  }
  return lines.join('\n').trim();
}

export function buildDataAuthDefault(translate, settings = {}) {
  const brand = settings.appName || settings.CompanyName || 'Movex';
  const email = settings.contact_email || '';
  const parts = [
    tv(translate, 'data_auth_para1'),
    tv(translate, 'data_auth_para2'),
    tv(translate, 'data_auth_para3'),
  ].filter(Boolean);
  if (email) {
    parts.push(`${tv(translate, 'data_auth_contact') || 'Contacto:'} ${email}`);
  }
  if (parts.length === 0) {
    return `Autorizo a ${brand} a tratar mis datos personales conforme a la Ley 1581 de 2012 y el Decreto 1377 de 2013, para gestionar mi cuenta, prestar los servicios contratados, atender PQR, cumplir obligaciones legales y enviar comunicaciones relacionadas con el servicio.`;
  }
  return parts.join('\n\n');
}

export function buildLegalContentFallback(contentKey, translate, settings = {}) {
  switch (contentKey) {
    case 'about':
      return buildAboutDefault(translate);
    case 'terms':
      return buildTermsDefault(translate, settings);
    case 'privacy':
      return buildPrivacyDefault(translate, settings);
    case 'faq':
      return buildFaqDefault(translate);
    case 'dataAuth':
      return buildDataAuthDefault(translate, settings);
    default:
      return '';
  }
}

export function mergeLegalContentDefaults(settings, translate) {
  const s = { ...(settings || {}) };
  if (!s.aboutUsContent?.trim()) s.aboutUsContent = buildAboutDefault(translate);
  if (!s.termsContent?.trim()) s.termsContent = buildTermsDefault(translate, s);
  if (!s.privacyContent?.trim()) s.privacyContent = buildPrivacyDefault(translate, s);
  if (!s.faqContent?.trim()) s.faqContent = buildFaqDefault(translate);
  if (!s.dataAuthContent?.trim()) s.dataAuthContent = buildDataAuthDefault(translate, s);
  return s;
}
